import { render, staticRenderFns } from "./Delete-Dialog.vue?vue&type=template&id=d0b41764"
import script from "./Delete-Dialog.vue?vue&type=script&lang=js"
export * from "./Delete-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports